module.exports = __webpack_public_path__ + "media/images/cats-835d862c02d6ce3fd5eb7f11435a3073.jpg";